import { Predicates } from "../predicates/predicates";

export class URL {
  static createSearchParams<T extends Object>(
    data: T,
    queryString?: string
  ): URLSearchParams {
    const searchParams = new URLSearchParams(queryString);

    for (const [key, value] of Object.entries(data)) {
      if (Predicates.isNotNullAndNotUndefined(value))
        searchParams.append(key, value.toString());
    }

    return searchParams;
  }
}
